// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4993":"56ea4659","5252":"5fb86255","6041":"5fb86255","7320":"81bbbdd3","7358":"5fb86255","7558":"f64f2ff4","8847":"60e251c2"}[chunkId] + ".chunk.css";
};